/*global aswb, translate moment*/

/**
 * Init ASWB Functions - Pure JS version of Document Ready.
 */
// eslint-disable-next-line no-unused-vars
document.addEventListener('DOMContentLoaded', function (event) {
  localStorage.setItem('aswb_running', 'no');

  // Adds the necessary WC body classes for Product loop.
  jQuery(document.body).addClass('woocommerce woocommerce-page woocommerce-js');

  // Get Cache.
  const cache = getCachedData();

  // Init all calenders.
  // eslint-disable-next-line @wordpress/no-unused-vars-before-return
  const calendars = aswbSetupCalendars();

  // Trigger by ID
  if (cache && cache.triggerID) {
    const triggerEarly = findTriggerTarget(cache.triggerID);

    if (triggerEarly) {
      aswbPrepareRequest(triggerEarly);
    }
    return;
  }

  // Any that has to be triggered right now, because of load_on_search
  if (calendars.length && calendars[0]) {
    aswbPrepareRequest(calendars[0]);
  } else if (aswb.search_on_load && aswb.search_on_load === 'on') {
    // Trigger Any shortcode
    const anyShortcode = findTriggerTarget();

    if (anyShortcode) {
      aswbPrepareRequest(anyShortcode);
    }
  }
}); // End document ready.

// Event Listeners.
jQuery(document).on('click', 'button.aswb-button', function (event) {
  event.preventDefault();

  aswbPrepareRequest(this); // Load Products
});

// Event 2. if pagination is clicked, load the next page.
jQuery(document).on('click', '.aswb-results a.page-numbers', function (event) {
  const element = jQuery(event.target);

  // Make sure it's ASWB and not standard pagination.
  if (element.closest('.aswb-wrapper').length) {
    // Prevent default WC from firing.
    event.preventDefault();

    const url = jQuery(this).attr('href');
    const paged = url.split('&paged=');

    aswbPrepareRequest(this, paged[1]); //Load Products (feed in paged value)
  }
});

// Event 3. Allow user to hit enter from the keyword search.
jQuery('.aswb-keyword').on('keypress', function (event) {
  // Enter button.
  if (event.which === 13) {
    aswbPrepareRequest(this); // Load Products
    event.preventDefault();
  }
});

/**
 * Gets the products via AJAX and returns them as html.
 *
 * @param event
 * @param paged
 */
function aswbPrepareRequest(event, paged) {
  //  Make sure search only runs one at a time on a browser.
  if (localStorage.getItem('aswb_running') && localStorage.getItem('aswb_running') === 'yes') {
    return;
  }

  localStorage.setItem('aswb_running', 'yes');

  let target;

  // If our event is nicely formatted get an jquery object from it.
  // Used for triggers.
  if (event && event.shortcode) {
    event = event.shortcode;
  }
  // Get the target.
  target = findShortcodeData(event);
  // Check if we are redirecting or triggering another shortcode.
  target = aswbMaybeRedirect(target);

  if (!target) {
    return;
  }

  const searchData = aswbCreateSearchData(target, paged);

  // Clone the submit button.
  const originalState = jQuery(target.submitButton).clone();

  // Send Request.
  jQuery.ajax({
    type: 'GET',
    dataType: 'JSON',
    url: aswb.ajax_url,
    data: searchData,
    timeout: 240000, // 4 minutes as milliseconds.
    beforeSend() {
      if (aswb.debug_mode === 'on') {
        console.log(searchData);
      }
      // Show button spinner.
      jQuery(target.submitButton).html('<div class="aswb-spinner"></div>');

      // Remove classes.
      jQuery(target.results).removeClass('aswb-results-loaded');
      jQuery(target.results).removeClass('aswb-results-error');
      jQuery(target.results).removeClass('aswb-results-has-availability');
      jQuery(target.results).removeClass('aswb-results-no-availability');

      jQuery(target.results).addClass('aswb-results-loading');
    },
    success(response) {
      if (aswb.debug_mode === 'on') {
        console.log(response);
      }
      jQuery(target.results).removeClass('aswb-results-loading');
      jQuery(target.results).addClass('aswb-results-loaded');
      // Stop showing button spinner.
      jQuery(target.submitButton).replaceWith(originalState);

      if (response.html) {
        jQuery(target.results).html(response.html);

        /**
         * Third-party support for when next products have loaded.
         */

        /**
         * Puri WooCommerce Product Images. Refresh the image carousels.
         */
        if (typeof pwpiController !== 'undefined' && typeof pwpiController.refresh === 'function') {
          pwpiController.refresh();
        }
      }

      if (response.availableBookings) {
        jQuery(target.results).addClass('aswb-results-has-availability');
      } else {
        jQuery(target.results).addClass('aswb-results-no-availability');
      }

      localStorage.setItem('aswb_running', 'no');
    },
    // eslint-disable-next-line no-unused-vars
    error(request, status, error) {
      if (aswb.debug_mode === 'on') {
        console.log('There was an error with the Availability Search request.');
        console.log(request.responseText);
      }
      jQuery(target.results).removeClass('aswb-results-loading');
      jQuery(target.results).removeClass('aswb-results-loaded');
      jQuery(target.results).addClass('aswb-results-error');
      // Stop showing button spinner.
      jQuery(target.submitButton).replaceWith(originalState);
      // Results.
      jQuery(target.results).html(
        '<p>There has been an error. You may need to clear your cache, or contact support.</p>',
      );
      localStorage.setItem('aswb_running', 'no');
    },
  });
  // Remove Trigger id
  searchData.trigger = false;
  // Save the last data.
  saveSearchData(searchData);
  // Refresh all calendars with the new search data.
  aswbSetupCalendars();
}

function findTriggerTarget(triggerID) {
  // Get shortcodes
  const shortcodes = niceShortcodeArray();

  let target = false;

  if (triggerID) {
    // Find the shortcode by ID.
    target = shortcodes[triggerID] ? shortcodes[triggerID] : false;
  } else {
    target = false;
  }

  // if no target found by id, trigger the first shortcode that doesn't have a trigger.
  if (!target) {
    for (const key in shortcodes) {
      if (
        shortcodes[key] &&
        shortcodes[key].attributes &&
        !shortcodes[key].attributes.trigger &&
        !shortcodes[key].attributes.results_page
      ) {
        target = shortcodes[key];
        break;
      }
    }
  }

  return target;
}

function getCachedData() {
  const data = localStorage.getItem('aswb_search_data');

  if (data) {
    return JSON.parse(data);
  }
  return false;
}

function findShortcodeData(object) {
  // .closest() finds the first element UP the dom. We should always get the right one.
  const shortcode = jQuery(object).closest('div.aswb-wrapper');

  const attributes = shortcode.data('aswb');

  let findCategory = '';

  if (shortcode.find('select.aswb-category-selector').length > 0) {
    // find the dropdown category.
    findCategory = shortcode.find('select.aswb-category-selector');
  } else if (shortcode.find('input.aswb-category-selector-radio:checked').length > 0) {
    // find the checked radio category.
    findCategory = shortcode.find('input.aswb-category-selector-radio:checked');
  }

  // Dynamically find all aswb-taxonomy-* dropdown downs.
  const taxonomies = shortcode.find("select[class^='aswb-taxonomy-']").length
    ? shortcode.find("select[class^='aswb-taxonomy-']")
    : false;

  const target = {
    shortcode,
    attributes,
    form: shortcode.find('form.aswb-search'),
    submitButton: shortcode.find('.aswb-submit'),
    results: shortcode.find('.aswb-results'),
    daterange: shortcode.find('input.aswb-datepicker'),
    keyword: shortcode.find('input.aswb-keyword'),
    categorySelected: findCategory,
    taxonomies,
  };

  return target;
}

/**
 * Find all ASWB Shortcodes and put them into a nice array.
 */
function niceShortcodeArray() {
  const shortcodes = jQuery('div.aswb-wrapper');

  const neatObject = {};

  let i;
  for (i = 0; i < shortcodes.length; i++) {
    const data = findShortcodeData(shortcodes[i]);

    if (data.attributes && data.attributes.id && data.attributes.id.length > 0) {
      const newID = data.attributes.id;
      neatObject[newID] = data;
    } else {
      neatObject[i] = data;
    }
  }

  return neatObject;
}

function aswbSetupCalendars() {
  const today = moment();

  const searchOnLoad = [];

  // Setup each instance of calendar date pickers.
  jQuery('input.aswb-datepicker').each(function (index, datepicker) {
    // TODO Create a better way to handle shortcode overrides

    // Get the Data of the shortcode.
    const target = findShortcodeData(datepicker);

    if (!target) {
      return;
    }

    aswbApplyRememberedData(target);

    let singleDate;

    if (target.attributes.datepicker === 'single') {
      singleDate = true;
    } else if (target.attributes.datepicker === 'range') {
      singleDate = false;
    } else {
      singleDate = aswb.single_date_picker === 'on' ? true : false;
    }

    // Return all shortcodes that need reloading for later.
    if (target.attributes.search_on_load && target.attributes.search_on_load === 'true') {
      searchOnLoad.push(target);
    }
    const hasTimeSupport = aswb.time_support === 'on' ? true : false;

    const dateRange = aswbGetDateRange(hasTimeSupport);

    // Get the datepicker object.
    datepicker = jQuery(datepicker);

    // Config datepicker.
    datepicker.daterangepicker(
      {
        startDate: dateRange.start,
        endDate: dateRange.end,
        minDate: aswb.min_date ? moment(aswb.min_date) : today,
        singleDatePicker: singleDate,
        timePicker: hasTimeSupport,
        timePicker24Hour: aswb.time_format === '24hour' ? true : false,
        timePickerIncrement: aswb.time_increments ? parseInt(aswb.time_increments) : 30,
        locale: {
          direction: aswb.date_picker_alignment === 'left' ? 'rtl' : 'ltr',
          format: aswb.date_format,
          separator: ' ' + translate.separator + ' ',
          applyLabel: translate.applyLabel,
          cancelLabel: translate.cancelLabel,
          fromLabel: translate.fromLabel,
          toLabel: translate.toLabel,
          customRangeLabel: 'Custom',
          weekLabel: translate.weekLabel,
          daysOfWeek: [
            translate.sunday,
            translate.monday,
            translate.tuesday,
            translate.wednesday,
            translate.thursday,
            translate.friday,
            translate.saturday,
          ],
          monthNames: [
            translate.january,
            translate.february,
            translate.march,
            translate.april,
            translate.may,
            translate.june,
            translate.july,
            translate.august,
            translate.september,
            translate.october,
            translate.november,
            translate.december,
          ],
          firstDay: parseInt(aswb.start_of_week),
        },
        opens: aswb.date_picker_alignment,
        drops: target.attributes.drops ? target.attributes.drops : 'auto',
        autoApply: target.attributes.auto_apply_dates ? true : false, // False for now, make optional later
        buttonClasses: 'btn btn-sm aswb-datepicker-buttons',
        applyButtonClasses: 'aswb-apply-button',
        cancelButtonClasses: 'aswb-cancel-button',
      },
      // eslint-disable-next-line no-unused-vars
      function (start, end, label) {
        const resultsPage = target.attributes.results_page;

        if (!aswb.search_on_date_change) {
          return;
        }
        // Search has a results page.
        if (resultsPage && resultsPage.length) {
          // Only trigger the search from date picker if we are on the results page.
          if (resultsPage && window.location.pathname !== resultsPage) {
            return;
          }
        }

        return aswbPrepareRequest(this.element[0]);
      },
    );

    // Always Show Calender feature.
    if (aswb.always_show_calendar === 'on') {
      // range update listener
      // eslint-disable-next-line no-unused-vars
      datepicker.on('apply.daterangepicker', function (ev, picker) {
        aswbPrepareRequest(datepicker.context);
      });
      // prevent hide after range selection
      datepicker.data('daterangepicker').hide = function () {};
      // show picker on load
      datepicker.data('daterangepicker').show();
    }
  }); // end of foreach

  // Return the search on load object. We can modify this later to handle more custom.
  return searchOnLoad;
}

function aswbMaybeRedirect(target) {
  const resultsPage = target.attributes.results_page;
  const triggerID = target.attributes.trigger;

  // Check if we are already on the page.
  if (resultsPage && window.location.pathname !== resultsPage) {
    // Redirect to the right page.
    const trigger = target.attributes.trigger ? target.attributes.trigger : 'any';

    aswbCreateSearchData(target, false, trigger);

    window.location.href = target.attributes.results_page;

    return false;
  }

  // Display Results in the next available shortcode.
  if (triggerID) {
    // Get & save the search data.
    aswbCreateSearchData(target);
    aswbSetupCalendars();

    // Change target to a specific shortcode.
    target = findTriggerTarget(triggerID);

    return target;
  }

  return target;
}

function saveSearchData(data) {
  // Save Search Data in storage.
  localStorage.setItem('aswb_search_data', JSON.stringify(data));

  return data;
}

/**
 * Set the last data in the form.
 *
 * @param target
 */
function aswbApplyRememberedData(target) {
  const searchedData = getCachedData();

  if (!searchedData) {
    return;
  }

  // Set remembered last keyword.
  if (target.keyword) {
    target.keyword.val(searchedData.keyword ? searchedData.keyword : '');
  }

  // Set remembered category for dropdown and radio.
  if (target.categorySelected && searchedData.category_selected) {
    if (target.attributes.category_selector === 'radio') {
      const findRadio = target.shortcode.find(
        'input.aswb-category-selector-radio[value=' + searchedData.category_selected + ']',
      );
      // check the radio category.
      if (findRadio.length > 0) {
        findRadio.prop('checked', true);
      }
    } else {
      const allDropdownOptions = target.shortcode.find(jQuery(target.categorySelected.selector + ' option'));

      const optionValues = [];

      // Create an array of all dropdown values.
      allDropdownOptions.each(function () {
        optionValues.push(jQuery(this).val());
      });
      // set the value dropdown value exits and is searched before.
      if (optionValues.includes(searchedData.category_selected)) {
        target.categorySelected.val(searchedData.category_selected);
      }
    }
  }

  // Apply remembered taxonomies.
  if (target.taxonomies && searchedData.taxonomies) {
    // For each taxonomy on the page.
    target.taxonomies.each(function (index) {
      const taxName = jQuery(target.taxonomies[index]).attr('name');

      if (taxName) {
        // Get the tax value.
        const taxValue =
          searchedData.taxonomies[taxName] && searchedData.taxonomies[taxName].length
            ? searchedData.taxonomies[taxName]
            : '';
        // Only apply the tax value if the select has the option.
        if (jQuery(target.taxonomies[index]).find("option[value='" + taxValue + "']").length) {
          jQuery(target.taxonomies[index]).val(taxValue);
        }
      }
    });
  }
}

/**
 * Create the search data for the server.
 *
 * @param {*} target
 * @param {*} paged
 * @param {*} trigger
 */
function aswbCreateSearchData(target, paged, trigger) {
  // get the start momentJS let.
  const start = jQuery(target.daterange).data('daterangepicker').startDate;
  // get the end momentJS let.
  const end = jQuery(target.daterange).data('daterangepicker').endDate;

  // Full day if time support is not needed.
  if (!aswb.time_support || aswb.time_support === 'off') {
    // Set hours to be the full day.
    start.startOf('day');
    end.endOf('day');
  }

  // if datepicker is single.
  if (aswb.single_date_picker === 'on' || target.attributes.datepicker === 'single') {
    end.endOf('day');
  }

  aswbRememberDates(start, end);

  if (target.attributes.results_page) {
    trigger = target.attributes.trigger ? target.attributes.trigger : 'any';
  }

  // Data to pass to the search.
  const searchData = {
    action: 'aswb_process_search_request',
    paged: paged ? paged : 1, // Page number from pagination.
    search_type: aswb.search_type, // bring in the search type for easy debugging.
    category_selected: jQuery(target.categorySelected).length ? target.categorySelected.val() : '',
    category_include: target.attributes.category_include,
    category_exclude: target.attributes.category_exclude,
    keyword: target.keyword && target.keyword.val() ? target.keyword.val() : '',
    start_timestamp: start.unix(),
    end_timestamp: end.unix(),
    start_formatted_time: start.format('YYYY-MM-DD H:mm'),
    end_formatted_time: end.format('YYYY-MM-DD H:mm'),
    attributes: target.attributes,
    triggerID: trigger, // ID of a shortcode or 'any.
    taxonomies: aswbTaxonomiesValue(target.taxonomies),
  };

  saveSearchData(searchData);

  return searchData;
}

/**
 * Get taxonomy names and selected term ID's into a nice array.
 *
 * @param {*} taxonomies taxonomies found by jQuery.
 */
function aswbTaxonomiesValue(taxonomies) {
  const niceTax = {};

  if (taxonomies) {
    taxonomies.each(function (index) {
      // eslint-disable-next-line @wordpress/no-unused-vars-before-return
      const taxName = jQuery(taxonomies[index]).attr('name');
      const termID = jQuery(taxonomies[index]).val();

      if (!termID || termID === 0 || termID === '0') {
        // continue; in jQuery.
        return;
      }

      if (niceTax[taxName]) {
        niceTax[taxName].push(termID);
      } else {
        niceTax[taxName] = [termID];
      }
    });
  }

  return niceTax;
}

/**
 * Works out the default dates to use for our daterange picker settings
 * Takes Params from php and localStorage if requested.
 * Used in aswbSetupCalendars()
 *
 * @param hasTimeSupport
 */
function aswbGetDateRange(hasTimeSupport = false) {
  const minimumDate = moment(aswb.min_date ? aswb.min_date : undefined);

  let startDate = moment(aswb.min_date ? aswb.min_date : undefined);
  let endDate = moment(aswb.min_date ? aswb.min_date : undefined);

  let resetDates = true;

  // Has remembered dates.
  if (localStorage.getItem('aswb_end_date') && localStorage.getItem('aswb_start_date')) {
    const savedStart = moment(localStorage.getItem('aswb_start_date'));
    const savedEnd = moment(localStorage.getItem('aswb_end_date'));

    // We are only dealing with full date ranges.
    if (!hasTimeSupport) {
      savedStart.startOf('day');
      savedEnd.endOf('day');

      startDate.startOf('day');
      endDate.endOf('day');
      minimumDate.startOf('day');
    }

    // If our start date is the later than our minimum date.
    // If our end is later than our start and later than our minimum date.
    if (
      savedStart.isSameOrAfter(minimumDate) &&
      savedEnd.isSameOrAfter(startDate) &&
      savedEnd.isSameOrAfter(minimumDate)
    ) {
      startDate = savedStart;
      endDate = savedEnd;
      resetDates = false;
    }
  }

  if (resetDates) {
    const dayOffset = parseInt(aswb.offset_start_day);
    const defaultRange = parseInt(aswb.default_date_range);
    const range = parseInt(dayOffset) + parseInt(defaultRange);

    startDate = minimumDate.clone().add(dayOffset, 'days');
    endDate = minimumDate.clone().add(range, 'days');
  }

  // Return the range as a object.
  const dateRange = {
    start: startDate,
    end: endDate,
  };

  return dateRange;
}

/**
 * Remember Dates via local storage. Requires start & end moment objects.
 *
 * @param start
 * @param end
 */
function aswbRememberDates(start, end) {
  //  localStorage/sessionStorage for remembering
  if (typeof Storage !== 'undefined') {
    localStorage.setItem('aswb_start_date', start.format('YYYY-MM-DD HH:mm'));
    localStorage.setItem('aswb_end_date', end.format('YYYY-MM-DD HH:mm'));
  }
}
